var map = {
	"./zh.advertManage.json": "tAEE",
	"./zh.articleManage.json": "uUOi",
	"./zh.common.json": "x1lf",
	"./zh.component.json": "I9Lu",
	"./zh.home.json": "NuZY",
	"./zh.serviceManage.json": "X8Gj",
	"./zh.systemManage.json": "G3We",
	"./zh.webManage.json": "8NzD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Q2ds";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales [A-Za-z0-9-_,\s]+\.json$/
// module id = Q2ds
// module chunks = 63 64